import { render } from "./help-message-dialog.vue?vue&type=template&id=e82a7a1e"
import script from "./help-message-dialog.vue?vue&type=script&lang=js"
export * from "./help-message-dialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__